const services = [
  {
    id: "1",
    title: "Health Assessments",
    icon: "fa fa-stethoscope fa-lg",
    image: "stethoscope.svg",
    shortIntro:
      "Health assessments with the view of preventing or detecting different medical conditions.",
    introDescriptions: [
      "Medicare subsides a number of Health Assessments that you can take advantage of by booking an appointment with your doctor:"
    ],
    items: [
      "75+ Health Assessments",
      "45-49 years old Health Assessments",
      "40-49 years old at risk of Type 2 Diabetes",
      "ATSI adult Health Assessments",
      "ATSI children Health Assessments",
      "Disability Health Assessments"
    ],
    sections: [
      {
        title: "Health assessments",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "Annual check-ups are recommended for anyone aged 40 years and over.",
              "This assists in the early detection and prevention of common medical conditions and diseases such as high blood pressure, heart and vascular disease, diabetes and cancers.",
              "Where appropriate your doctors conduct the Medicare subsidised 40 – 49 years old at risk of type 2 diabetes and 45 – 49 years old health checks.",
              "75 + Health Assessment, ASTI Adults and children health assessment as well as disability assessment.",
              "The doctors we support recommend health assessments for younger age groups in certain situations, for example a strong family history of cancer, heart disease or diabetes.",
              "The Doctors we support conduct thorough histories and examinations during preventative health checks.",
              "A fasting blood test is often included.  Cholesterol and blood glucose is regularly checked.",
              "Importantly all assessments are followed by the provision of a management plan tailored to your individual needs. This will include review appointments with your doctor as necessary.",
              "If you would like to arrange an appointment for a preventative health check, please contact our reception staff on (02) 6025 2189 Please allow 60 minutes for your appointment."
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: true,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "2",
    title: "Flu shot vaccines",
    icon: "fa fa-syringe fa-lg",
    image: "vaccine.svg",
    shortIntro:
      "Quick and simple flu vaccination administered in the upper arm by a nurse or doctor.",
    introDescriptions: [
      "The Majority of Australians benefit from having a yearly flu vaccination. Whilst groups such as 65+ years old, children and those who are pregnant are those most at risk"
    ],
    items: [],
    sections: [
      {
        title: "Flu Vaccines",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "A nurse or your doctor can give the injection which is usually given into the upper arm and only takes a few seconds",
              "The vaccines change each year, based on predictions of which flu strains will be most active that coming winter. They are usually given around late autumn to provide protection over the flu season. Your immunity is highest during 3-4 months after getting the flu shot therefore, we highly recommend getting immunised before the start of flu season to stay protected.",
              "Remember it’s important to get re-vaccinated every year to protect yourself against the flu viruses circulating that year. Your doctor will be able to advise you on the most adequate vaccine for you and your family, based on your age, vaccine availability and eligibility to receive vaccination free of charge."
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: false,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "3",
    title: "Travel health care",
    icon: "fa fa-plane-departure fa-lg",
    image: "travel.svg",
    shortIntro:
      "Stay healthy overseas with personalised travel vaccination advice and recommendations from your GP.",
    introDescriptions: [
      "The doctors we support here at GPs on Vermont are able to advise you on any preparations needed for your future trips. It’s important to protect your health when you’re travelling inside and/or outside Australia.",
      "With appropriate planning and health checks, you can avoid diseases and other health conditions.",
      "Overseas travel exposes people to various unfamiliar environments.",
      "Your doctor's goal is to provide current travel and health advice and offer vaccinations."
    ],
    items: [
      "Cholera (oral)",
      "Diptheria",
      "Flu vaccine",
      "Hepatitis A",
      "Hepatitis B",
      "Japanese B Encephalitis",
      "Measles, Mumps, Rubella",
      "Meningitis",
      "Pneumonia",
      "Polio",
      "Rabies (pre exposure)",
      "Typhoid (injection)"
    ],
    sections: [
      {
        title: "Travel Health Services",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "Fitness to travel certificates",
            descriptions: [
              "The doctors we support understand everyone is managing a busy schedule and we are committed to ensuring availability to suit any timetable."
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title: "Travel immunisations",
            descriptions: [
              "Your doctor is able to advise on specific immunisation requirements for different regions around the world. Even if you have been immunised in the past, it is still recommended to speak with a doctor just to be on the safe side."
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title: "International Health advice",
            descriptions: [
              "The doctors we support are knowledgeable about specific immunisation requirements for different regions around the world. If you have been immunised in the past it is still recommended you speak with your doctor to ensure you are up to date with any travel health information.",
              "The doctors we support are well informed by the Department of Health of seasonal and other outbreaks around the world."
            ]
          }
        ]
      },
      {
        title: "frequently asked questions",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "I’m planning on travelling. When should I see my doctor?",
            descriptions: [
              "The doctors we support recommend you make an appointment to see your GP 6-12 weeks before you travel. Remember the sooner the better! That way you have enough time to do all the checks and apply any advice your GP may recommend to ensure you are healthy and ready before your trip."
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title:
              "I’m a mature traveller and/or have pre-existing conditions. Is it safe for me to travel?",
            descriptions: [
              "Talk to your GP and let them know where you are going and ask for preventative advice that suits your needs. Travelling could put your health at risk, especially if you need specific care that may be hard to find overseas. It’s better to know all your options so you don’t risk your health."
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title: "Do I really need vaccinations?",
            descriptions: [
              "Yes!, Depending on where you are travelling to, there are many diseases that can be prevented if you receive the appropriate vaccination. Remember to leave enough time before your trip to ask your doctor which vaccines you need as some vaccinations take several weeks to become active."
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title:
              "I’m pregnant. What do I need to do to ensure my baby and I are safe?",
            descriptions: [
              "Remember you are making decisions for two, so it is best to not only make an appointment with your GP but also see your obstetrician, talk to your travel insurer and airline. They will all advice you on what steps to take to reduce the risks to you and your baby."
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title:
              "Do I need any vaccination certificates to enter overseas countries?",
            descriptions: [
              "Talk to your GP about your destination and they will inform you of what vaccinations are required. Some do require a certificate, such as the Yellow Fever vaccination."
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: true,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "4",
    title: "Counselling",
    icon: "fa fa-heartbeat fa-lg",
    image: "headbrain.svg",
    shortIntro:
      "Counselling is an empowering process that encourages individuals to confront issues and problems and to work at restoring well-being.",
    introDescriptions: [
      "The counselling process is a planned, structured dialogue between a counsellor and a client.",
      "It is a cooperative process in which a trained professional helps a person called the client to identify sources of difficulties or concerns that he or she is experiencing.",
      "A counsellor will demonstrate unconditional acceptance, genuineness and empathy and will try to understand things from your perspective."
    ],
    items: [],
    sections: [],
    enabled: false
  },
  {
    id: "5",
    title: "General Practice Care",
    icon: "fa fa-laptop-medical fa-lg",
    image: "care.svg",
    shortIntro:
      "Care for all ages, including women’s, men’s and children’s health, chronic conditions and injuries.",
    introDescriptions: [
      "The doctors who consult from GP’s on Vermont Medical Centre are committed to providing continuous long-term patient care for all ages and types of people including individuals, couples and families.",
      "The doctors we support specialise in a broad range of health areas including women’s health, men’s health, children’s health, injures, mental health and  chronic illness. For your doctor it is all about your needs and desired health outcomes.",
      "This clinic and the doctors consulting here provide equity of access to quality care for all Australians regardless of their race, sex, age, religion, socioeconomic status or location. Good access includes affordability, the availability of appointments, intensive care, and the ability to access your GP of choice.",
      "We and the doctors who consult from GPs on Vermont Medical Centre are determined to treat every patient equally and with respect. The General Practicioners consulting here have knowledge which is extensive, and they are 100% sure that they can provide a solution that best suits each individual’s situation."
    ],
    items: [
      "Women’s health",
      "Men’s health",
      "Children’s health",
      "Refugee health",
      "Chronic illness",
      "Minor surgeries",
      "Diving medicals",
      "Electrocardiogram (E.C.G)",
      "Lung Function testings(Spirometry)",
      "Family planning",
      "Care of aged or disabled",
      "Heart checks",
      "Skin checks",
      "Liquid Nitrogen freezing for sunspots/warts",
      "Minor surgery",
      "Ear syringing",
      "Weight loss",
      "Workcover (VIC and NSW) Comcare, TAC (motor vehicle)",
      "Pre-employment and general health medicals."
    ],
    sections: [
      {
        title: "General Practice Services",
        topics: [
          {
            icon: "",
            type: "CARD",
            title: "Women's health",
            descriptions: [
              "Antenatal care",
              "Cervical Screening test (pap smear)",
              "Breast checks",
              "Implanon insertion and removals",
              "Gardasil vaccinations",
              "Sexual health and STI checks",
              "Family planning",
              "Menopausal changes"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "Men's health",
            descriptions: [
              "Men’s health",
              "Sexual health and STI checks",
              "Prostate check",
              "Erectile dysfunction",
              "Mental health care plan"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "Children's Health",
            descriptions: [
              "Childhood immunisations",
              "4 years Old Healthy Kids checks",
              "Childhood illnesses"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "Minor surgery",
            descriptions: [
              "Insertion and removal of implanon (rod)",
              "Wound management",
              "Cryotherapy"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "Chronic Illness",
            descriptions: [
              "Screening and detection of chronic illness",
              "Patient education",
              "Preparation of care plans and team care arrangements"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "Mental health",
            descriptions: [
              "Depression",
              "Anxiety ",
              "Stress",
              "Post-traumatic stress",
              "Obsessive compulsive disorders",
              "Sexual dysfunction",
              "Anger management",
              "Relationship difficulties",
              "Work related issues"
            ]
          }
        ]
      },
      {
        title: "Frequently asked Questions",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "How do i make a booking with my doctor?",
            descriptions: [
              "You can book online or call us on (02) 6025 2189 during business hours from Monday to Saturday or clicking on the “Book an Appointment” button on our website. Sometimes your doctor may even take same day appointments!"
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title: "How long before my appointment with my doctor should I arrive?",
            descriptions: [
              "To give the doctors the ability to run on time and fill out needed paperwork, we recommend arriving to your appointment about 5-10 mins before your scheduled time."
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title:
              "Can I fill out the New Patient registration form before I come in?",
            descriptions: [
              "Yes, we highly recommend filling out the registration form before to save you some time! Link to hotdoc new patient registration form."
            ]
          },
          {
            icon: "",
            type: "PARAGRAPH",
            title: "What if I can’t make it to my appointment with my doctor?",
            descriptions: [
              "Out of respect to your doctors we highly recommend to inform us of any cancellations within 24/48 hours’ notice. Same day cancellations may impact the chance to book in the future with your doctor."
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: true,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "6",
    title: "Dept. of Veteran Affairs",
    icon: "fa fa-user-nurse fa-lg",
    image: "medal.svg",
    shortIntro:
      "Support and services for war veterans, Defence Force members, Federal Police members and their dependants.",
    introDescriptions: [
      "The main objective is to maintain and enhance the physical and mental wellbeing and quality of life of eligible persons and their dependants through health and other care services that promote early intervention, prevention and treatment including advice and information about health services entitlements.",
      "The Department of Veterans' Affairs (DVA) is a primary service delivery agency responsible for developing and implementing programs that assist the veteran and defence force communities.",
      "The Australian Government's commitment to the delivery of efficient and effective mental health services. DVA provides suicide awareness and prevention support for current and ex-serving Australian Defense Force personnel and their families who are experiencing or have been affected by the thoughts or actions of suicide."
    ],
    items: [],
    sections: [],
    displayGeneralBookingButton: true,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "7",
    title: "Sexual Health",
    icon: "fa fa-pills fa-lg",
    image: "medication.svg",
    shortIntro:
      "Support for preventing and managing sexually transmissible infections for people of all ages.",
    introDescriptions: [
      "Sexually transmitted infection (STI) screening is offered by the doctors consulting here for their patients. The screening can be conducted during a regular consultation with your doctor and can include a discussion about safe sex practices. As many STI’s can occur without the patient experiencing symptoms, screening is recommended as part of a patient’s health check.",
      "Your doctor asks that you book a 20-minute appointment for a sexual health check. To arrange an appointment with your Doctors, please phone (02) 6025 2189 or book online."
    ],
    items: [],
    sections: [],
    displayGeneralBookingButton: true,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "8",
    title: "Occupational health",
    icon: "fa fa-hard-hat fa-lg",
    image: "worker.svg",
    shortIntro:
      "Full employment  medical services and injury management.",
    introDescriptions: [
      "The doctors we support at GPs on Vermont provide tailored advice for your company based on their expert professional opinion, so you are aware of the minimum standards needed when employing staff."
    ],
    items: [
      "Pre Employment Medicals",
      "Executive Health Assessments",
      "Fitness for Duty",
      "Basic Physical Fitness Test",
      "Spirometry (Respiratory function)",
      "Audiometry (hearing)",
      "Psychological Testing",
      "Drug and Alcohol Testing",
      "Pathology Tests",
      "Urine Test",
      "Further Vision Tests",
      "Chest X Ray"
    ],
    sections: [
      {
        title: "Pre-Employement medicals",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "Pre-employment medicals are increasingly an essential task in the recruiting process to identify the most suitable candidates for the specific roles you’re trying to hire for.",
              "The doctors we support provide a needs-based assessment for each candidate case. Most HR managers and small to medium business owners are unaware of the dynamic differences that are required from role to role and therefore the doctors consulting here can assist you with that advice on what’s expected from you.",
              "Your doctor will take everyone candidate through a basic medical assessment and then proceed with role specific testing, followed by any in depth assessment that may arise from any individual risk. These may involve audiometry, spirometry, sleep studies, exercise stress testing or functional capacity testing.",
              "These can also be performed for employees with role specific requirements such as heavy physical work as a base part of their day-to-day activities"
            ]
          }
        ]
      },
      {
        title: "Executive health assessments",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "An Executive Health Assessment fits in with the overall Needs-Based style of service provision. The doctors we support want to leave every stone unturned in evaluating executive health, but they are not in the business of placing individuals at further risk or saying ‘yes’ to all requests and companies in the interest of simply raising earnings.",
              "The doctors we support want to help you protect your company, the investment you have in an individual, and the continuity of your dealings long term. Lower your insurance premiums, limit time away from work and increase productivity in the most caring way possible.",
              "All examinations are performed with the highest level of due diligence and the doctors consulting here hope that this translates to a healthier workforce for your company and its staff. Enquire with us about what the doctors consulting here can do for your Executives today."
            ]
          }
        ]
      },
      {
        title: "Fitness for duty",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "Small injuries can be a long-term burden on your business and really dent your momentum. While you may be covered in case of injury, it is important to maintain a good rapport with your employees and demonstrate that your interests are mutually aligned.",
              "If you look after them while they are sick with more than just sick-pay and a work cover claim number, it should come back to you in productivity and more importantly, loyalty. This is easier said than done of course, but every little bit helps.",
              "Making sure they are ready to go back to work while injured (at work or at home) or allowing them to perform some lighter duties can really help cover you legally, but more importantly allow you to care for your workers."
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: true,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "9",
    title: "Child Immunization",
    icon: "fa fa-baby fa-lg",
    image: "child.svg",
    shortIntro:
      "The National Immunisation Program funds vaccinations against 13 diseases for Australian children aged 0–4 year",
    introDescriptions: [
      "Under the National Immunisation Program, vaccination is free for Australian children.",
      "Immunisation from an early age helps protect your child against serious childhood infections.",
      "The Immunisation Schedule Victoria outlines the vaccines your child needs and the age at which each vaccine should be given.",
      "Some groups are more at risk than others in the community and may need additional vaccines.",
      "Remain in the clinic with your child for at least 15 minutes after their immunisation to be sure there are no immediate side effects.",
      "Serious side effects or allergic reactions to the vaccines are rare."
    ],
    items: [],
    sections: [
      {
        title: "Vaccines",
        topics: [
          {
            icon: "",
            type: "CARD",
            title: "Birth",
            descriptions: ["Hepatitis B"]
          },
          {
            icon: "",
            type: "CARD",
            title: "2 Months",
            descriptions: [
              "HepB-DTPa_Hib_IPV (hepatitis B, diphtheria, tetanus, acellular pertussis (whooping cough), Haemophilus influenzae type B, polio)",
              "Pneumococcal vaccine (13vPCV)",
              "Rotavirus"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "4 Months",
            descriptions: [
              "HepB-DTPa_Hib_IPV (hepatitis B, diphtheria, tetanus, acellular pertussis (whooping cough), Haemophilus influenzae type B, polio)",
              "Pneumococcal vaccine (13vPCV)",
              "Rotavirus"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "6 Months",
            descriptions: [
              "HepB-DTPa_Hib_IPV (hepatitis B, diphtheria, tetanus, acellular pertussis (whooping cough), Haemophilus influenzae type B, polio)",
              "Pneumococcal vaccine (13vPCV) for Aboriginal and Torres Strait Islander children and medically at-risk children.",
              "Rotavirus (third dose is dependent on the brand of vaccine used)",
              "Influenza (annually) – for those with certain medical risk factors 6 months and over and Aboriginal and Torres Strait Islander children 6-months to 5 years."
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "12 Months",
            descriptions: [
              "Measles, mumps and rubella (MMR)",
              "Meningococcal ACWY",
              "Pneumococcal vaccine (13vPCV)",
              "Aboriginal and Torres Strait Islander children in high-risk areas: Hepatitis A – 1st dose"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "18 Months",
            descriptions: [
              "Haemophilus influenza type B (Hib)",
              "Measles, mumps, rubella, chickenpox (MMRV)",
              "DTPa",
              "Aboriginal and Torres Strait Islander children: Hepatitis A – 2nd dose"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "4 years",
            descriptions: [
              "DTPa-IPV (Diphtheria, tetanus, acellular pertussis (whooping cough) and inactivated polio)",
              "Children medically at-risk: Pneumococcal vaccine (23vPPV)"
            ]
          },
          {
            icon: "",
            type: "CARD",
            title: "10-15 years (depends on state or Territory)",
            descriptions: [
              "Human papilloma virus (HPV): usually 2 doses",
              "DTPa"
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: false,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "10",
    title: "Chronic disease management",
    icon: "fa fa-file-medical fa-lg",
    image: "pill.svg",
    shortIntro:
      "Your GP can help plan and coordinate appropriate ongoing healthcare through Medicare programs.",
    introDescriptions: [],
    items: [],
    sections: [
      {
        title: "",
        topics: [
          {
            icon: "",
            type: "CARD",
            title:
              "In general practice, a care plan is a process for setting and achieving health goals. This involves:",
            descriptions: [
              "Assessment of the patient’s condition(s) in relation to overall health and functionality",
              "Outlining the practitioner’s goals for the patient",
              "Addressing the patient/carer’s needs and goals",
              "Planning treatments and actions that will meet the goals, and planning review steps."
            ]
          },
          {
            icon: "",
            type: "CARD",
            title:
              "If your GP involves other health care professionals as well, the plan may also include:",
            descriptions: [
              "Collaboration between other health care professionals or support staff to prepare the plan",
              "Recording of each party’s goals and the treatment",
              "Care planned to meet those goals, and regular review of the care arrangements"
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: true,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "11",
    title: "Aboriginal health",
    icon: "fa fa-flag fa-lg",
    image: "aboriginalflag.svg",
    shortIntro:
      "Supporting physical, social, emotional and cultural wellbeing for individuals and the wider community.",
    introDescriptions: [],
    items: [],
    sections: [
      {
        title: "Gwambunna and Welcome!",
        topics: [
          {
            icon: "",
            type: "CARD",
            title:
              "Aboriginal and Torres Strait Islander people can access a health check annually, with a minimum claim period of 9 months. 715 health checks are free at Aboriginal Medical Services and bulk bulling clinics to help people stay healthy and strong.",
            descriptions: [
              "Delivery of culturally responsive services for all Aboriginal and Torres Strait Islander patients and their families. Assessment of the patient’s condition(s) in relation to overall health and functionality",
              "Availability of appropriate health services and preventative care for Aboriginal people.",
              "Helping ensure the practice meets the particular needs of ATSI patients and their families and increase the cultural sensitivity of healthcare services and providers to Aboriginal health issues.",
              "Build positive relationships with the Victorian Aboriginal community, other service providers, and government departments."
            ]
          }
        ]
      },
      {
        title: "Acknowledment of country",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "GPs on Vermont Medical Centre and the doctors consulting here acknowledge and pay respect to the traditional custodians and original owners of this land, the Wiradjuri people, and recognise the continuing connection to land, waters and culture. We pay respect to those that have passed before us and acknowledge all elders past, present and emerging."
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: false,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "12",
    title: "LGBTQI+ community",
    icon: "fa fa-rainbow fa-lg",
    image: "rainbow.svg",
    shortIntro:
      "Welcoming, inclusive care that supports the diverse healthcare needs of LGBTQI+ patients.",
    introDescriptions: [
      "The doctors we support are striving to ensure sensitive and equitable care for individuals who identify as lesbian, gay, bisexual, transgender, or queer (LGBTQ). Yet many doctors and nurses find gaps in knowledge when caring for LGBTQ patients",
      "The doctors we support approach patients with open-mindedness and a nonjudgmental attitude. Their job as a healthcare professional is to assist the person in solving a health concern or reducing the risk of future health problems.",
      "It’s also important to build your awareness of the specific physical health problems LGBTQ individuals face. Lesbian women are more at risk for certain cancers due to the prevalence of obesity, nulliparity, or later pregnancy.",
      "Lesbian women are susceptible to many of the same sexually transmitted infections as heterosexual people and gay men. Thinking that this population isn’t at risk for these STIs can result in lack of appropriate screening and treatment. In addition to HIV infection, gay men may be at higher risk for anal cancer and can be particularly susceptible to body image issues in the desire to be attractive to other men. They may also experience a variety of cancers resulting from increased obesity and use of tobacco and alcohol."
    ],
    items: [],
    sections: [],
    displayGeneralBookingButton: true,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "13",
    title: "skin checks",
    icon: "fa fa-search fa-lg",
    image: "skincheck.svg",
    shortIntro:
      "Regular skin checks and early detection help identify and treat skin cancer.",
    introDescriptions: [
      "Skin cancer is by far the most common cancer in Australia, killing 5 people every day.",
      "Australia has the highest incidence of skin cancer in the world. Not all of them are melanoma’s. In fact nonmelanoma skin cancers in Australia are now nearly seven times more common than all other cancers combined; approximately half of these are removed by general practitioners.",
      "As part of their patients' continuity of care, the doctors consulting here recommend regular skin checks to be able to detect any changes as soon as possible."
    ],
    items: [],
    sections: [],
    displayGeneralBookingButton: false,
    displayBookingButtonFor: [
      {
        id: "dr-angela-ramsay",
        name: "Dr Angela Ramsay"
      }
    ],
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "14",
    title: "Covid-19 Vaccines",
    icon: "fa fa-virus-covid fa-lg",
    image: "vaccine.svg",
    shortIntro:
      "The Australian government recommends COVID-19 vaccines for everyone 5 years and older.",
    introDescriptions: [
      "The protection someone gains from having COVID-19 varies from person to person."
    ],
    items: [],
    sections: [
      {
        title: "covid-19 Vaccines",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "The government recommends that people who have had COVID-19 and recovered should still be vaccinated, approximately 3 months after the confirmed infection, whether that’s an initial shot or a booster dose.",
              "A nurse or your doctor can give the injection which is usually given into the upper arm and only takes a few seconds.",
              "The vaccines will change with time, based on predictions of which strains will be most active. That’s why it’s important to keep your boosters up to date as the virus is still circulating and people can get re-infected or infected with a different strain."  
            ]
          }
        ]
      },
      {
        title: "Queries and concerns",
        topics: [
          {
            icon: "",
            type: "CARD",
            title: "If you have any concerns your doctor will be able to advise you on the whether the vaccine is appropriate for you and your family, based on your",
            descriptions: ["Age", "Health", "Vaccine availability", "Vaccine eligibility"]
          }
        ]
      }
    ],
    displayGeneralBookingButton: false,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "15",
    title: "weight loss clinic",
    icon: "fa fa-weight fa-lg",
    image: "skincheck.svg",
    shortIntro:
      "Early detection and regular skin examinations are your best chances at preventing, identifying and treating skin cancers.",
    introDescriptions: [
      "Skin cancer is by far the most common cancer in Australia, killing 5 people every day.",
      "Australia has the highest incidence of skin cancer in the world. Not all of them are melanoma’s. In fact nonmelanoma skin cancers in Australia are now nearly seven times more common than all other cancers combined; approximately half of these are removed by general practitioners.",
      "As part of our patients continuity of care we recommend regular skin checks with us to be able to detect any changes as soon as possible."
    ],
    items: [],
    sections: [],
    displayGeneralBookingButton: false,
    displayBookingButtonFor: [
      {
        id: "dr-virajinee-rathnayake",
        name: "Dr Virajinee Rathnayake"
      }
    ],
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "16",
    title: "Q Fever Vaccine",
    icon: "fa fa-syringe fa-lg",
    image: "vaccine.svg",
    shortIntro:
      "Q-VAX® is recommended for people aged 15+ who have contact with high-risk animals or animal products.",
    introDescriptions: [
      "People may also require the vaccine if they do activities in regional and rural areas where there is exposure to high-risk animals such as cattle, sheep or goats."
    ],
    items: [],
    sections: [
      {
        title: "Q Fever Vaccines",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "Q fever is a bacterial infection caused by exposure to the Q fever bacterium Coxiella burnetii. The bacteria is usually passed from animals to humans, especially after exposure to contaminated air, soil or dust.",
              "A Q fever infection causes flu-like symptoms that can be severe and in some people may cause long-term health issues.",
              "The Q fever vaccine though highly effective is unfortunately not suitable for everyone. If you have a known egg proteins allergy, are pregnant or are a child under 15 years of age you should not have the vaccine.",
              "If you have a weakened immune system, have had Q fever previously or are being treated for another health condition you will need to arrange a pre-vaccination screening with your doctor as you may not be eligible for the vaccine.",
              "A pre-vaccination screening with your doctor can help to identify who can be vaccinated.",
              "If you have any concerns your doctor will be able to advise you on the whether or not the vaccine is right for you."
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: false,
    displayCallUsButton: true,
    enabled: true
  },
  {
    id: "17",
    title: "Yellow Fever Vaccine",
    icon: "fa fa-syringe fa-lg",
    image: "vaccine.svg",
    shortIntro:
      "Serious mosquito-borne disease affecting Africa and South America, with vaccination requirements for travellers.",
    introDescriptions: [
      "The yellow fever vaccine is a live attenuated virus given as a single injection. It provides long-lasting protection and is highly effective in preventing the disease. In Australia, it’s only available through accredited yellow fever vaccination centres, and cannot be purchased at pharmacies."
    ],
    items: [],
    sections: [
      {
        title: "Yellow Fever Vaccines",
        topics: [
          {
            icon: "",
            type: "PARAGRAPH",
            title: "",
            descriptions: [
              "Who should get it: Anyone aged 9 months or older travelling to or through yellow fever endemic areas.",
              "Dosage: A single dose is sufficient for lifelong protection in most cases.",
              "Timing: You must receive the vaccine at least 10 days before travel to meet international entry requirements.",
              "Documentation: After vaccination, you’ll receive an International Certificate of Vaccination or Prophylaxis, which may be required for border entry."
            ]
          }
        ]
      }
    ],
    displayGeneralBookingButton: false,
    displayCallUsButton: true,
    enabled: true
  }

];

export default services;
